import { render, staticRenderFns } from "./SchedulingBasisUnScheduling.vue?vue&type=template&id=00c8d7d2&scoped=true"
import script from "./SchedulingBasisUnScheduling.vue?vue&type=script&lang=js"
export * from "./SchedulingBasisUnScheduling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c8d7d2",
  null
  
)

export default component.exports